import {
  createFileRoute,
  redirect,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { DownloadIcon, FileTextIcon } from "lucide-react";
import { Button, buttonVariants } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_app/document-redactor/result")({
  component: RouteComponent,
  beforeLoad({ location: { state } }) {
    if (!state.documentRedactResult)
      throw redirect({ to: "/document-redactor" });
  },
});

function RouteComponent() {
  const redactResult = useLocation({
    select: (s) => s.state.documentRedactResult,
  });

  const navigate = useNavigate();
  const handleClickStart = () => {
    navigate({ to: "/document-redactor" });
  };
  if (!redactResult) return null;
  return (
    <div className="px-4 py-6">
      <div className="mb-8 flex justify-between space-y-2 max-md:flex-col">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">
            Document Redactor
          </h1>
          <p className="text-muted-foreground">
            Masks/Highlightes PIIs on your files
          </p>
        </div>
        <div>
          <Button
            variant="outline"
            className="mt-5 flex h-10 cursor-pointer items-center gap-2 max-md:w-full"
            onClick={handleClickStart}
          >
            <FileTextIcon className="size-4" />
            <span>Start New</span>
          </Button>
        </div>
      </div>
      <Card className="flex justify-center justify-items-center">
        <span className="m-auto max-md:text-center">
          Your document has been redacted successfuly
        </span>
      </Card>
      <div className="mt-8 flex justify-center">
        <a
          className={cn(
            buttonVariants({ variant: "outline" }),
            "border-primary text-primary",
          )}
          href={redactResult.output_file_url}
          download
        >
          <DownloadIcon />
          Download
        </a>
      </div>
    </div>
  );
}
